<template>
    <b-modal size="lg" ref="modalAssocia" id="modalAssociaOperatore" title="Associa Operatore" scrollable centered>
        <div class="sa-page-search-component">
            <b-form style="width: 100%" @submit.prevent="onSubmit">
                <b-row class="sa-form-btn-filter">
                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Nome</label>
                        <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                            <input class="sa-page-search-component-input" v-model="mdlFiltroUsers.firstname" placeholder="Inserisci nome operatore.." />
                        </div>
                    </b-col>
                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Cognome</label>
                        <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                            <input class="sa-page-search-component-input" v-model="mdlFiltroUsers.lastname" placeholder="Inserisci cognome operatore.." />
                        </div>
                        <button class="sa-page-search-component-btn-search" title="Search">
                            <i class="fas fa-search"></i>
                        </button>
                        <button class="sa-page-search-component-btn-reset" @click="resetFiltriConfigurazioneDevice" type="button"><i class="fas fa-trash"></i></button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <div class="b-table-sticky-header">
            <b-table sticky-header :busy="isBusy" ref="table" stacked="lg" striped hover :items="items" :fields="fieldsModal" sort-icon-left head-variant="light" class="sa-b-table" current-page="1" :per-page="perPageUsers">
                <template #table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Caricamento...</strong>
                    </div>
                </template>
                <template #cell(firstname)="row">
                    <p>{{ row.item.lastname }} {{ row.item.firstname }}</p>
                </template>
                <template v-slot:cell(checkBox)="{ item }">
                    <b-form-checkbox v-model="item.check" size="md" switch class="sa-normal-label"> </b-form-checkbox>
                </template>
                <template #cell(action)="row">
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!row.item.check" size="md" variant="outline-success" class="btn-sim" @click="onAssocia(row.item)">
                            <b-icon icon="person-check-fill" aria-hidden="true"></b-icon>
                            Associa
                        </b-button>
                        <b-button v-else variant="outline-danger" size="md" class="btn-sim" @click="onDeleteAssociazione(row.item)">
                            <b-icon icon="person-x-fill" aria-hidden="true"></b-icon>
                            Dissocia
                        </b-button>
                    </div>
                </template>
            </b-table>
        </div>

        <template #modal-footer="{ ok }">
            <b-button size="sm" variant="outline-danger" @click="ok()">
                <b-icon icon="x"></b-icon>
                Annulla
            </b-button>
        </template>
    </b-modal>
</template>

<script>
//import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    components: {},
    mixins: [UtilityMixin],
    data() {
        return {
            isBusy: false,
            showModalLoading: false,
            perPage: 10,
            perPageUsers: 100000,
            currentPage: 1,
            currentPageUsers: 1,
            pathResource: "/users",
            pathResourceDeviceOperatore: "/devicedevicesimoperatori",
            mdlFiltroUsers: {
                lastname: "",
                firstname: "",
            },
            obj: { params: null },
            items: [],
            associazioni: [],

            fieldsModal: [
                {
                    label: "",
                    thStyle: "width: 2.5rem",
                    tdClass: "text-center",
                },
                {
                    label: "Cognome",
                    key: "lastname",
                    sortable: true,
                },
                {
                    label: "Nome",
                    key: "firstname",
                    sortable: true,
                },
                {
                    label: "Profilo",
                    key: "profilo",
                    sortable: true,
                },
                {
                    label: "",
                    key: "action",
                    tdClass: "text-right",
                },
            ],
        };
    },
    created: function () {},
    mounted() {},
    methods: {
        init(idDevice) {
            let me = this;
            me.idDevice = idDevice;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let mdlFiltroUsers = sessionStorage.getItem("mdlFiltroUsers");
            if (mdlFiltroUsers) {
                me.mdlFiltroUsers = JSON.parse(mdlFiltroUsers);
            }
            me.show(me.mdlFiltroUsers);
        },
        show(filtro) {
            let me = this;
            me.associazioni = [];
            me.loadData(filtro);
            me.$refs.modalAssocia.show();
            me.loadDataDeviceOperatore();
        },
        loadData(filtro) {
            let me = this;
            me.loadDataResources(me.pathResource, filtro, me.resultResponseData, me.resultErrorData);
        },
        resultResponseData(response) {
            let me = this;
            me.items = [];
            me.items = response.data.data.list;
            me.mergeAssociazioni();
        },
        resultErrorData(error) {
            let messaggio = error.response.data.messaggio;
            console.log(messaggio);
        },
        onAssocia(item) {
            let me = this;
            let esisteGia = me.associazioni.some((associazione) => associazione.idOperatore === item.id);
            if (esisteGia) {
                return;
            }
            let obj = {
                id: null,
                idOperatore: item.id,
                idDevice: me.idDevice,
            };
            me.associaOperatore(obj);
        },
        associaOperatore(obj) {
            let me = this;
            obj.statoAttuale = "ATTIVO";
            obj.statoAttualeDataOra = new Date().getTime();
            obj.dataInizioAssociazione = new Date().getTime();
            me.saveResource(me.pathResourceDeviceOperatore, obj, me.resulResponseSave, null);
        },
        resulResponseSave(response) {
            let me = this;
            me.$refs["modalAssocia"].hide();
            response.data.data;
            me.showModalLoading = false;
            me.$emit("afterSave");
            this.$bvToast.toast("Operatore Associato", {
                title: this.getLabelTraduora("ambulatory.toastAssociateUserSuccess"),
                solid: true,
                variant: "success",
                autoHideDelay: 1000,
                appendToast: true,
            });
        },
        onDeleteAssociazione(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm(this.getLabelTraduora("ambulatory.modelMessageConfirmDeleteAssociate"), {
                    title: this.getLabelTraduora("ambulatory.modelMessageDeleteAssociate"),
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteAssociazione(item);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteAssociazione(item) {
            let me = this;
            me.showModalLoading = true;
            let idAssociazione = item.idAssociazione;
            me.loadDataResources(me.pathResourceDeviceOperatore + "/" + idAssociazione, {}, me.deleteAssociazioneSuccess, me.deleteAssociazioneError);
        },
        deleteAssociazioneSuccess(response) {
            let me = this;
            let record = response.data.data;
            record.dataFineAssociazione = new Date().getTime();
            me.saveResource(me.pathResourceDeviceOperatore, record, me.resulResponseSaveDissociazione, (error) => {
                console.error("Errore nel salvataggio dissociazione", error);
                me.showModalLoading = false;
            });
        },
        deleteAssociazioneError(error) {
            let me = this;
            console.error("Errore nel caricamento associazione per disassociazione", error);
            me.showModalLoading = false;
        },
        resulResponseSaveDissociazione(response) {
            let me = this;
            me.$refs["modalAssocia"].hide();
            response.data.data;
            me.showModalLoading = false;
            me.$emit("afterSave");
            this.$bvToast.toast("Operatore Dissociato", {
                title: this.getLabelTraduora("ambulatory.toastAssociateUserSuccess"),
                solid: true,
                variant: "success",
                autoHideDelay: 1000,
                appendToast: true,
            });
        },
        resetFiltriConfigurazioneDevice() {
            let me = this;
            me.mdlFiltroUsers.firstname = "";
            me.mdlFiltroUsers.lastname = "";
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("mdlFiltroUsers", JSON.stringify(me.mdlFiltroUsers));
            me.loadData();
        },
        loadDataDeviceOperatore() {
            let me = this;
            me.loadDataResources(me.pathResourceDeviceOperatore + "/associati", { idDevice: me.idDevice }, me.resultDeviceOperatore, me.resultErrorDeviceOperatore);
        },
        resultDeviceOperatore(response) {
            let me = this;
            me.associazioni = response.data.data;
            me.mergeAssociazioni();
        },
        resultErrorDeviceOperatore(error) {
            console.log(error);
        },
        mergeAssociazioni() {
            let me = this;

            if (!me.items.length) {
                return;
            }

            me.items = me.items.map((item) => {
                let associazione = me.associazioni.find((associazione) => associazione.idOperatore === item.id);

                return {
                    ...item,
                    check: !!associazione,
                    idAssociazione: associazione ? associazione.id : null,
                };
            });
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("mdlFiltroUsers", JSON.stringify(me.mdlFiltroUsers));
            me.loadData(me.mdlFiltroUsers);
        },
    },
};
</script>
<style scoped>
.btn-sim {
    min-width: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
